(function () {
  "use strict";

  var whatsappBase = "https://wa.me/525542388056?text=";

  function encodeMessage(message) {
    return whatsappBase + encodeURIComponent(message.trim());
  }

  function setupProductImageFallback() {
    var image = document.querySelector("[data-product-image]");
    var wrapper = document.querySelector("[data-product-image-wrap]");

    if (!image || !wrapper) {
      return;
    }

    var fallbackSrc = image.getAttribute("data-fallback-src") || "";
    var triedFallback = false;

    function tryFallbackImage() {
      if (!fallbackSrc || triedFallback) {
        return false;
      }

      triedFallback = true;
      image.src = fallbackSrc;
      image.removeAttribute("srcset");
      return true;
    }

    function showPlaceholder() {
      image.classList.add("is-missing");
      wrapper.classList.add("has-placeholder");
    }

    if (image.complete && image.naturalWidth <= 1) {
      if (!tryFallbackImage()) {
        showPlaceholder();
      }
    }

    image.addEventListener("error", function () {
      if (!tryFallbackImage()) {
        showPlaceholder();
      }
    });
    image.addEventListener("load", function () {
      if (image.naturalWidth <= 1) {
        if (!tryFallbackImage()) {
          showPlaceholder();
        }
        return;
      }

      wrapper.classList.add("has-image");
    });

    var probe = new Image();
    probe.onload = function () {
      if (probe.naturalWidth <= 1) {
        showPlaceholder();
        return;
      }

      wrapper.classList.add("has-image");
    };
    probe.onerror = showPlaceholder;
    probe.src = image.currentSrc || image.src;
  }

  function setupMobileNav() {
    var toggle = document.querySelector(".nav-toggle");
    var nav = document.querySelector("#site-navigation");

    if (!toggle || !nav) {
      return;
    }

    function setOpen(isOpen) {
      toggle.setAttribute("aria-expanded", String(isOpen));
      toggle.setAttribute("aria-label", isOpen ? "Cerrar navegación" : "Abrir navegación");
      nav.setAttribute("data-open", String(isOpen));
    }

    toggle.addEventListener("click", function () {
      setOpen(toggle.getAttribute("aria-expanded") !== "true");
    });

    nav.addEventListener("click", function (event) {
      if (event.target instanceof HTMLAnchorElement) {
        setOpen(false);
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        setOpen(false);
      }
    });
  }

  function setupFaq() {
    var questions = document.querySelectorAll(".faq-question");

    questions.forEach(function (question) {
      var answerId = question.getAttribute("aria-controls");
      var answer = answerId ? document.getElementById(answerId) : null;

      if (!answer) {
        return;
      }

      question.addEventListener("click", function () {
        var isOpen = question.getAttribute("aria-expanded") === "true";
        question.setAttribute("aria-expanded", String(!isOpen));
        answer.hidden = isOpen;
      });
    });
  }

  function setupChat() {
    var toggle = document.querySelector(".chat-toggle");
    var panel = document.querySelector("#chat-panel");
    var close = document.querySelector(".chat-close");
    var textarea = document.querySelector("#chat-message");
    var sendLink = document.querySelector("#chat-whatsapp-link");
    var quickButtons = document.querySelectorAll("[data-chat-message]");

    if (!toggle || !panel || !textarea || !sendLink) {
      return;
    }

    function updateLink() {
      sendLink.href = encodeMessage(textarea.value || "Hola, quiero comprar Alicyn 100 ml.");
    }

    function setOpen(isOpen) {
      panel.hidden = !isOpen;
      toggle.setAttribute("aria-expanded", String(isOpen));
      toggle.setAttribute("aria-label", isOpen ? "Cerrar ayuda por WhatsApp" : "Abrir ayuda por WhatsApp");

      if (isOpen) {
        window.setTimeout(function () {
          textarea.focus();
        }, 0);
      } else {
        toggle.focus();
      }
    }

    toggle.addEventListener("click", function () {
      setOpen(panel.hidden);
    });

    if (close) {
      close.addEventListener("click", function () {
        setOpen(false);
      });
    }

    textarea.addEventListener("input", updateLink);

    quickButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        textarea.value = button.getAttribute("data-chat-message") || "";
        updateLink();
        textarea.focus();
      });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !panel.hidden) {
        setOpen(false);
      }
    });

    updateLink();
  }

  function setupReviewsCarousel() {
    var carousels = document.querySelectorAll("[data-reviews-carousel]");
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    carousels.forEach(function (carousel) {
      var track = carousel.querySelector("[data-reviews-track]");
      var previous = carousel.querySelector("[data-reviews-prev]");
      var next = carousel.querySelector("[data-reviews-next]");
      var timer = null;
      var isPaused = false;

      if (!track) {
        return;
      }

      function getStep() {
        var firstCard = track.querySelector(".review-card");
        if (!firstCard) {
          return track.clientWidth;
        }

        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
        return firstCard.getBoundingClientRect().width + gap;
      }

      function scrollByStep(direction) {
        var step = getStep() * direction;
        var maxScroll = track.scrollWidth - track.clientWidth - 4;
        var nextLeft = track.scrollLeft + step;

        if (nextLeft > maxScroll) {
          nextLeft = 0;
        } else if (nextLeft < 0) {
          nextLeft = maxScroll;
        }

        track.scrollTo({
          left: nextLeft,
          behavior: reduceMotion ? "auto" : "smooth"
        });
      }

      function start() {
        if (reduceMotion || timer || isPaused) {
          return;
        }

        timer = window.setInterval(function () {
          scrollByStep(1);
        }, 5000);
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      if (previous) {
        previous.addEventListener("click", function () {
          scrollByStep(-1);
        });
      }

      if (next) {
        next.addEventListener("click", function () {
          scrollByStep(1);
        });
      }

      carousel.addEventListener("pointerenter", function () {
        isPaused = true;
        stop();
      });

      carousel.addEventListener("pointerleave", function () {
        isPaused = false;
        start();
      });

      carousel.addEventListener("focusin", function () {
        isPaused = true;
        stop();
      });

      carousel.addEventListener("focusout", function () {
        isPaused = false;
        start();
      });

      start();
    });
  }

  function setupReviewFilters() {
    var sections = document.querySelectorAll(".experiences");

    sections.forEach(function (section) {
      var buttons = section.querySelectorAll("[data-review-filter]");
      var cards = section.querySelectorAll("[data-review-piercing]");
      var track = section.querySelector("[data-reviews-track]");

      if (!buttons.length || !cards.length) {
        return;
      }

      buttons.forEach(function (button) {
        button.addEventListener("click", function () {
          var filter = button.getAttribute("data-review-filter") || "all";

          buttons.forEach(function (item) {
            item.setAttribute("aria-pressed", String(item === button));
          });

          cards.forEach(function (card) {
            var matches = filter === "all" || card.getAttribute("data-review-piercing") === filter;
            card.hidden = !matches;
          });

          if (track) {
            track.scrollTo({ left: 0, behavior: "smooth" });
          }
        });
      });
    });
  }

  function setupAjaxCartForms() {
    var forms = document.querySelectorAll("[data-ajax-cart-form]");

    forms.forEach(function (form) {
      if (form.getAttribute("data-ajax-ready") === "true") {
        return;
      }

      form.setAttribute("data-ajax-ready", "true");

      form.addEventListener("submit", function (event) {
        if (!window.fetch || !window.FormData) {
          return;
        }

        event.preventDefault();

        var button = form.querySelector("button[type='submit']");
        var status = form.querySelector("[data-cart-status]");
        var formData = new FormData(form);
        var originalText = button ? button.textContent : "";
        var action = form.getAttribute("action") || "/cart/add";
        var endpoint = action.indexOf(".js") > -1 ? action : action.replace(/\/cart\/add\/?$/, "/cart/add.js");

        formData.delete("return_to");

        if (button) {
          button.disabled = true;
          button.textContent = "Agregando...";
        }

        if (status) {
          status.textContent = "Agregando al carrito...";
        }

        fetch(endpoint, {
          method: "POST",
          body: formData,
          credentials: "same-origin",
          headers: {
            "Accept": "application/json"
          }
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().catch(function () {
                return {};
              }).then(function (payload) {
                throw new Error(payload.description || "No se pudo agregar al carrito.");
              });
            }

            return response.json();
          })
          .then(function () {
            var actionType = form.getAttribute("data-cart-action");
            if (button) {
              button.textContent = "Agregado";
            }
            if (status) {
              status.innerHTML = actionType === "checkout"
                ? 'Agregado. <a href="/checkout">Finalizar compra</a>'
                : 'Agregado. <a href="/cart">Ver carrito</a>';
            }

            document.dispatchEvent(new CustomEvent("alicyn:cart:add", {
              bubbles: true,
              detail: {
                form: form
              }
            }));
          })
          .catch(function (error) {
            if (status) {
              status.textContent = error.message || "No se pudo agregar. Intenta desde el producto.";
            }
            if (button) {
              button.textContent = originalText;
            }
          })
          .finally(function () {
            window.setTimeout(function () {
              if (button) {
                button.disabled = false;
                if (button.textContent === "Agregado") {
                  button.textContent = originalText;
                }
              }
            }, 1600);
          });
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    setupProductImageFallback();
    setupMobileNav();
    setupFaq();
    setupChat();
    setupReviewsCarousel();
    setupReviewFilters();
    setupAjaxCartForms();
  });
})();
